var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"layout-standard"},[_vm._t("header",function(){return [_c('ViewLayoutHeader')]}),_vm._t("default",function(){return [_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)]}),_vm._t("footer",function(){return [_c('ViewLayoutNavigationTabs'),_c('ViewLayoutActionPanel')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }